__turbopack_context__.v({
  "className": "nunito_sans_18585bb7-module__HxkAhG__className",
});
